module.exports = __webpack_public_path__ + "static/media/dop-dex.b105a80a.svg";